// Acronym-aware titleizer — one source of truth for Transform Operations (TransformOps) and
// its shared ConstraintDetail, so an initiative / gap / resource key never renders two ways
// across the constraint table and its detail. Works for every tenant's keys, not a fixed map.

const ACRONYMS = new Set([
  'awv', 'hcc', 'tcm', 'toc', 'cdi', 'npi', 'tin', 'emr', 'ed', 'er',
  'pcp', 'dme', 'p4p', 'aco', 'spv', 'acd', 'adt',
]);

export function titleize(key) {
  return (key || '—').split(/[\s_]+/)
    .map(w => (ACRONYMS.has(w.toLowerCase()) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ');
}
